/*
 * Størrelsesguide overlay. Spec: docs/content-pages-spec.md.
 *
 * The trigger is the "Størrelsesguide" link in the size option row. It stays a real <a> to
 * /pages/storrelsesguide so it works without JS, is middle-clickable, and is crawlable — this
 * only intercepts the plain left click and opens the overlay instead.
 */
(function () {
  const TRIGGER = '.product__size-guide';

  function init() {
    const modal = document.getElementById('KardimaSizeGuide');
    const backdrop = document.querySelector('[data-size-guide-backdrop]');
    if (!modal || !backdrop) return;

    const panel = modal.querySelector('.kardima-sizing-modal__panel');
    let lastFocused = null;

    function open(event) {
      // Let modified clicks (new tab, download, middle click) behave normally.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();

      lastFocused = document.activeElement;
      modal.hidden = false;
      backdrop.hidden = false;
      // Force layout so the transition has a starting frame to animate from.
      void panel.offsetWidth;
      modal.setAttribute('data-open', '');
      backdrop.setAttribute('data-open', '');
      document.body.classList.add('overflow-hidden');

      const close = modal.querySelector('[data-size-guide-close]');
      if (close) close.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function hide() {
      modal.removeAttribute('data-open');
      backdrop.removeAttribute('data-open');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', onKeydown);

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        modal.hidden = true;
        backdrop.hidden = true;
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      };
      // transitionend does not fire under prefers-reduced-motion, so always keep a fallback.
      panel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 400);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') hide();
    }

    // Delegated: the variant picker is re-rendered on variant change (and by the size-select
    // script), which replaces the trigger link, so per-element listeners get lost.
    document.addEventListener('click', (event) => {
      if (event.target.closest && event.target.closest(TRIGGER)) open(event);
    });
    modal.querySelectorAll('[data-size-guide-close]').forEach((el) => el.addEventListener('click', hide));
    backdrop.addEventListener('click', hide);

    // Clicking the dimmed area beside the panel closes too.
    modal.addEventListener('click', (event) => {
      if (!panel.contains(event.target)) hide();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
